export const config = {
  service: {
    host: process.env.VUE_APP_ENDPOINT_URL,
  },
};
